export default {"src":"/_next/static/media/WHR.0b6c0d18.svg","height":18,"width":18};